import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import GoogleMapsNavigationButton from '@/components/Locations/subComponents/GoogleMapsNavigationButton.vue';
import slugify from '@/services/formattter/slugify';
export default defineComponent({
    name: 'locations-region-partner-stores',
    components: {
        GoogleMapsNavigationButton,
    },
    data() {
        return {
            hideMoreThanThree: true,
        };
    },
    methods: {
        toggleCards() {
            this.hideMoreThanThree = !this.hideMoreThanThree;
        },
        link(location) {
            return '/stores/' + slugify(location.name) + '--' + location.id;
        },
    },
    computed: Object.assign(Object.assign({}, mapState('global', { currentRegion: 'currentRegion', locations: 'locations' })), { buttonText() {
            if (this.hideMoreThanThree) {
                return 'Weitere Partnerstores der Region anzeigen';
            }
            return 'Weniger anzeigen';
        },
        shownLocations() {
            if (this.hideMoreThanThree) {
                return this.locations.filter((loc, index) => index < 3);
            }
            return this.locations;
        } }),
});
